import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  Optional,
  Self,
} from '@angular/core';
import { NgControl, Validators } from '@angular/forms';
import { isNullOrUndefined } from '@osos/shared/legacy-core';
import { fromEvent, merge } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ComponentBase } from '../../../data';
import { FormFieldControl } from '../form-field-control.directive';

let nextUniqueId = 0;

@Directive({
   
  selector: '[pInputText], [pInputTextarea]',
  providers: [
    {
      provide: FormFieldControl,
      useExisting: PrimeTextFormFieldControlDirective,
    },
  ],
  standalone: true,
})
export class PrimeTextFormFieldControlDirective
  extends ComponentBase
  implements FormFieldControl, OnInit
{
  private _uid = `p-text-component-${nextUniqueId++}`;

  /** Implemented as part of FormFieldControl. */
  @Input()
  @HostBinding()
  get id(): string {
    return this._id;
  }
  set id(value: string) {
    this._id = value || this._uid;
  }
  private _id: string;

  /** Implemented as part of FormFieldControl. */
  get disabled(): boolean {
    return this.ngControl?.disabled ?? false;
  }

  /** Implemented as part of FormFieldControl. */
  get required(): boolean {
    return this.ngControl?.control?.hasValidator(Validators.required) ?? false;
  }

  @HostBinding() class = 'w-full';

  @HostBinding('class.p-filled')
  private hasValue = false;

  constructor(
    @Optional() @Self() private ngControl: NgControl,
    private el: ElementRef,
  ) {
    super();
    // Force setter to be called in case id was not specified.
    this.id = this.id;
  }

  ngOnInit(): void {
    if (this.ngControl) {
      this.listenToNgControlChanges();
    } else {
      this.listenToHostChanges();
    }
  }

  listenToNgControlChanges() {
    this.hasValue = !isNullOrUndefined(this.ngControl.control?.value);

    this.ngControl.control?.valueChanges
      .pipe(
        tap((value) => {
          this.hasValue = !!value;
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  listenToHostChanges() {
    this.hasValue = !isNullOrUndefined(this.el.nativeElement.value);

    merge([
      fromEvent(this.el.nativeElement, 'change'),
      fromEvent(this.el.nativeElement, 'input'),
    ])
      .pipe(
        tap((_) => {
          this.hasValue = !isNullOrUndefined(this.el.nativeElement.value);
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();
  }
}
